<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/newIklient/loginImg.png"
                width="491.09px"
                height="341.98px"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h1
                    v-if="userObj.isFromOldIklient"
                    class="mb-4 text-primary"
                  >{{$t('confirmation.registrationConfirmation')}}</h1>

                  <h1 v-else class="mb-4 text-primary">{{$t('confirmation.fromOld')}}</h1>

                  <p>{{$t('confirmation.fillNewPassword')}}</p>
                </div>
                <form @click.prevent>
                  <vs-input
                    name="userName"
                    icon="icon icon-user"
                    icon-pack="feather"
                    v-validate="'required'"
                    :label-placeholder="$t('confirmation.emailOrUserName')"
                    v-model="userName"
                    class="w-full no-icon-border"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('userName')"
                  >{{ errors.first('userName') }}</span>

                  <vs-input
                    type="password"
                    name="password"
                    ref="password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    :label-placeholder="$t('confirmation.password')"
                    v-model="password"
                    v-validate="'required'"
                    class="w-full mt-6 no-icon-border"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password')"
                  >{{ errors.first('password') }}</span>
                  <vs-input
                    type="password"
                    name="password2"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Heslo znovu"
                    v-model="password2"
                    v-validate="'required|confirmed:password'"
                    class="w-full mt-6 no-icon-border"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password2')"
                  >{{ errors.first('password2') }}</span>
                  <div class="flex flex-col my-5"></div>
                  <vs-button
                    class="float-right mb-base"
                    @click.prevent="submitConfirmation"
                  >{{$t('confirmation.finishRegistration')}}</vs-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../api/RepositoryFactory";
const UserCalls = RepositoryFactory.get("user");
export default {
  data() {
    return {
      userName: "",
      password: "",
      password2: "",
      userObj: {}
    };
  },
  methods: {
    submitConfirmation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          UserCalls.confirmUserCredentials(
            this.userName,
            this.password,
            this.tokenObj()
          )
            .then(({ data }) => {
              this.$router.push({ name: "home" });
            })
            .catch(err => {
              if (err.response.data.codeType === 'USER_ALREADY_REGISTERED') {
                this.$vs.notify({
                  title: this.$t("error"),
                  text: 'Toto uživatelské jméno je již obsazené',
                  color: "danger"
                });
              } else if (err.response.data.codeType === 'INVALID_USERNAME_FORMAT') {
                this.$vs.notify({
                  title: this.$t("error"),
                  text: 'Neplatné uživatelské jméno',
                  color: "danger"
                });
              } else if (err.response.data.codeType === 'INVALID_PASSWORD_FORMAT') {
                this.$vs.notify({
                  title: this.$t("error"),
                  text: 'Heslo musí mít alespoň 6 znaků',
                  color: "danger"
                });
              } else {
                this.$vs.notify({
                  title: this.$t("error"),
                  text: this.$t("registration.errorFinishRegistration"),
                  color: "danger"
                });
              }
            });
        }
      });
    }
  },
  created() {
    this.userObj = this.$route.params.user;
    this.userName = this.userObj.userName;
    //   if(!this.getUserInfo().registrationDate){
    //       this.userObj = this.getUserInfo();
    //   }
  },
  mounted() {}
};
</script>
